export default __webpack_public_path__ + "static/media/lca_logo.a0276c70.svg";